var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureTileIcon05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 72,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.078%",
    y1: "100%",
    x2: "0%",
    y2: "7.585%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006DCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#338BF8",
    offset: "39.97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23FAD2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 36,
    cy: 36,
    r: 36
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-46.73%",
    y1: "64.95%",
    x2: "32.222%",
    y2: "64.95%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7E5FF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1 78L65.24 0l14.056 51.148C68.801 66.845 61.682 75.796 57.94 78c-5.614 3.307-28.415 13.266-33.415 10.633C21.192 86.878 13.35 83.333 1 78z",
    id: "e"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-33.2%",
    y: "-24.7%",
    width: "166.4%",
    height: "158.4%",
    filterUnits: "objectBoundingBox",
    id: "d"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.207843137 0 0 0 0 0.145098039 0 0 0 0 0.82745098 0 0 0 0.16 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7E5FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "18.063%",
    y2: "67.579%",
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7E5FF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.006 47.006a24.978 24.978 0 0 1 29.007-24.673C44.832 11.83 34.672 5.037 23.75 6.111 12.827 7.186 4.186 15.827 3.11 26.75 2.037 37.672 8.83 47.832 19.333 51.013a25.1 25.1 0 0 1-.327-4.007z",
    id: "i"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-57.8%",
    y: "-48.9%",
    width: "215.5%",
    height: "215.5%",
    filterUnits: "objectBoundingBox",
    id: "h"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.207843137 0 0 0 0 0.145098039 0 0 0 0 0.82745098 0 0 0 0.16 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.575 44.234a26.635 26.635 0 0 1 30.932-26.31C63.114 6.723 52.28-.52 40.633.625 28.986 1.771 19.771 10.986 18.625 22.633c-1.145 11.647 6.098 22.48 17.299 25.874a26.765 26.765 0 0 1-.35-4.273z",
    id: "l"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-41.7%",
    y: "-33.3%",
    width: "183.3%",
    height: "183.3%",
    filterUnits: "objectBoundingBox",
    id: "k"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.207843137 0 0 0 0 0.145098039 0 0 0 0 0.82745098 0 0 0 0.16 0",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#d)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#e"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14.13 61h-2.26a.273.273 0 0 1-.193-.08l-1.597-1.597a.273.273 0 0 1-.08-.193v-2.26c0-.072.029-.142.08-.193l1.597-1.597a.273.273 0 0 1 .193-.08h2.26c.072 0 .142.029.193.08l1.597 1.597c.051.051.08.12.08.193v2.26a.273.273 0 0 1-.08.193l-1.597 1.597a.273.273 0 0 1-.193.08z",
    fill: "url(#g)",
    opacity: 0.48,
    transform: "rotate(-31 37.303 -22.632)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-97 48.449 9.1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#h)",
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.72,
    fill: "url(#j)",
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45 1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#k)",
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#g)",
    xlinkHref: "#l"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTileIcon05);
export default __webpack_public_path__ + "static/media/feature-tile-icon-05.cef9e77d8751e161aed927d99bc41cbd.svg";
export { ForwardRef as ReactComponent };